import { UserRatingReport } from "../questionnaire/views/UserRatingReport";

function AllReports() {
  return (
    <div className="rated-users">
      <UserRatingReport />
    </div>
  );
}

export default AllReports;
